module.exports = __webpack_public_path__ + "img/badge_business.cae4a1a4.png";